import type { GAItem } from '../types';
import type { CommerceModel } from 'api-types';

type Options = {
  listId?: string;
  listName?: string;
  listType?: string;
  index?: number;
  quantity?: number;
};

/**
 * Maps a line item to a Google Analytics item.
 */

export function lineItemToGAItem(product: CommerceModel.LineItem, options: Options = {}): GAItem {
  const gaItem: GAItem = {
    item_id: product.productId,
    item_name: product.name || '',
    price: product.priceOutput?.unitPrice?.rawValue,
  };

  // Only add optional fields if they have actual values
  if (product.priceOutput?.currency) {
    gaItem.currency = product.priceOutput.currency;
  }
  if (product.brand) {
    gaItem.item_brand = product.brand;
  }
  if (product.id) {
    gaItem.item_variant = product.id;
  }
  if (product.category) {
    gaItem.item_category = product.category;
  }
  if (options?.index !== undefined) {
    gaItem.index = options.index;
  }
  if (options?.listName) {
    gaItem.item_list_name = options.listName;
  }
  if (options?.quantity) {
    gaItem.quantity = options.quantity;
  }

  return gaItem;
}
